import { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { allUsers as fetchAllUsers } from "@/redux/user/user.action";
import { Separator } from "@/components/ui/separator";
import DemoPage from "@/components/usersTable/page";
import { useAppDispatch } from "@/redux/hooks";
import { UserRoundPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { NewUserForm } from "@/components/NewUserForm";
import { useState } from "react";
export const UsersPage = () => {
  const dispatch = useAppDispatch();
  const [isNewUserFormOpen, setIsNewUserFormOpen] = useState<boolean>(false);
  useEffect(() => {
    dispatch(fetchAllUsers());
  }, [dispatch]);
  return (
    <>
      <Box className="flex flex-col p-4 h-full">
        <Card className="w-full h-full gap-0">
          <CardHeader className="flex flex-col gap-0">
            <div className="flex justify-between items-center w-full">
              <div className="flex flex-col">
                <CardTitle>
                  <Typography
                    fontFamily={"Inter"}
                    fontSize={"18px"}
                    fontWeight={500}
                  >
                    Usuarios
                  </Typography>
                </CardTitle>
                <CardDescription>
                  <Typography
                    fontFamily={"Inter"}
                    fontSize={"14px"}
                    fontWeight={400}
                  >
                    Gestiona, crea y edita los usuarios de la plataforma.
                  </Typography>
                </CardDescription>
              </div>
              <div>
                <Button
                  variant="icon"
                  size="icon"
                  onClick={() => setIsNewUserFormOpen(true)}
                >
                  <UserRoundPlus
                    className="min-w-6 min-h-6 max-w-6 max-h-6"
                    aria-label="add-user-icon"
                  />
                </Button>
              </div>
            </div>
            <Separator className="w-full mt-4 mb-2" />
          </CardHeader>
          <CardContent>
            <Typography
              fontFamily={"Inter"}
              fontSize={"14px"}
              fontWeight={600}
              className="mt-2"
            >
              Lista de usuarios
            </Typography>
            <DemoPage />
          </CardContent>
        </Card>
      </Box>
      <NewUserForm
        isNewUserFormOpen={isNewUserFormOpen}
        setIsNewUserFormOpen={setIsNewUserFormOpen}
      />
    </>
  );
};
